@if (currencyList) {
  <p-select
    appendTo="body"
    (onChange)="onCurrencyChange($event)"
    [options]="currencyList"
    [(ngModel)]="currency"
    [placeholder]="currency || 'Please select currency'"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
  >
  </p-select>
}
